module.exports = __webpack_public_path__ + "img/2f_r_tonya@2x.2a1d70ec.png";